import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetDataToken, useGetData } from "../../../hooks/useGetData";
import notify from "../../../Components/Utilities/notify";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";
import { useDeleteData } from "../../../hooks/useDeleteData";
import { useNavigate } from "react-router-dom";


//get all users
export const getCarts = createAsyncThunk(
    "/usersSlice/getCart",
    async ({id}) => {
        try {
            const response = await useGetData(`/api/v1/carts/${id}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);
export const getoneCart = createAsyncThunk(
    "/usersSlice/getCart",
    async (id='') => {
        try {
            const response = await useGetData(`/api/v1/carts/${id}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);
export const DeleteCartItem = createAsyncThunk(
    "/usersSlice/DeleteCartItem",
    async (id='') => {
        try {
            const response = await useDeleteData(`/api/v1/carts/${id}`);
            return id;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);
export const editCart = createAsyncThunk(
    
    "/usersSlice/editCart",
    async ({id='', data}) => {
        try {
            const response = await useUpdateData(`/api/v1/carts/${id}`, data);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);


export const addCart=createAsyncThunk(
    "/usersSlice/addCarts",
    async({data}, { rejectWithValue })=>{
        try {
            const response=await useInsertData('/api/v1/carts', data);
            console.log('res',response);
            return response;
        } catch (error) {
           // console.log('uuuuuuuuuuuuuuu',error.response.data);
            if (error.message == "Network Error")
            return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        else if (error.response) {
            rejectWithValue("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ")
            return notify(error.response.data.message || "An error occurred", "error");
          }
          else  {
                       rejectWithValue("حدث خطأ حاول مرة اخري");
                return notify(" حدث خطأ اثناء الاضافة من فضلك اكمل البيانات","error");
        }
            
        }
    }
);

// --------



